import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Title',
      placeholder: 'Enter notification title',
    },
    body: {
      label: 'Message Body',
      placeholder: 'Enter your message',
    },
    promo_code: {
      label: 'Promo code',
      placeholder: 'Select promo code',
    },
    offers: {
      label: 'Offers',
      placeholder: 'Select offer',
    },
    campaign_type: {
      label: 'Campaign type',
      placeholder: 'Select campaign type',
    },
    tone: {
      label: 'Tone of voice',
      placeholder: 'Select a tone',
    },
  },
  attachment: {
    heading: 'What should this campaign promote?',
    offer: {
      title: 'Offer',
      description: 'Pick from your active offers.',
    },
    promo_code: {
      title: 'Promo code',
      description: 'Pick from your active promo codes.',
    },
  },
  buttons: {
    generate: 'Generate',
    improve: 'Improve with AI',
    undo: 'Undo ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Friendly 🙂',
    [ToneTypes.Elegant]: 'Elegant ✨',
    [ToneTypes.Playful]: 'Playful 🎉',
    [ToneTypes.Professional]: 'Professional 👨‍💼',
    [ToneTypes.Informative]: 'Informative 📊',
    [ToneTypes.Persuasive]: 'Persuasive 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Promotional 🚀',
    [CampaignTypes.Informational]: 'Informational ℹ️',
  },
  no_promo_codes: {
    title: 'No eligible promo codes',
    description: 'Create a new promo code.',
    create_promo_code: 'Create promo code',
  },
  no_offers: {
    title: 'No activate offers',
    description: 'Create a new offer.',
    create_offer: 'Create offer',
  },
  feedback: {
    success: 'Successfully generated',
    error: 'Failed to generate',
  },
};
